import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/imports/products',
        name: 'imports.products',
        component: () => import('./pages/products/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/imports/suppliers',
        name: 'imports.suppliers',
        component: () => import('./pages/suppliers/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
] satisfies RouteRecordRaw[];
